<div id="login" class="inner-scroll" fxLayout="row" fxLayoutAlign="start">
  <app-wellcome />
  <div
    id="login-form-wrapper"
    [@animate]="{ value: '*', params: { delay: '300ms', x: '100%' } }"
  >
    <div id="login-form" *ngIf="isLogin">
      <div class="logo" fxHide.gt-xs>
        <img src="assets/images/logos/fuse.svg" />
      </div>
      <div class="title">ENTRAR</div>
      <form
        (ngSubmit)="onSubmit()"
        fxLayout="column"
        autocomplete="off"
        fxLayoutAlign="center center"
        name="loginForm"
        [formGroup]="loginForm"
        novalidate
      >
        <img
          [src]="sanitizeImagen(imagenLogin)"
          *ngIf="!showUsername"
          style="width: 150px; margin-bottom: 30px"
        />
        <mat-form-field *ngIf="showUsername" appearance="outline">
          <mat-label>Email</mat-label>
          <input
            matInput
            type="text"
            autocomplete="email"
            formControlName="username"
          />
          <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
        </mat-form-field>
        <br *ngIf="!showUsername" />
        <mat-form-field appearance="outline">
          <mat-label>Contraseña</mat-label>
          <input
            matInput
            [type]="showPassword ? 'text' : 'password'"
            (keyup)="inputPassword()"
            autocomplete="none"
            maxlength="16"
            formControlName="password"
          />
          <button
            (click)="checkPassword()"
            mat-icon-button
            matSuffix
            type="button"
            aria-label="mostrar"
          >
            <mat-icon>remove_red_eye</mat-icon>
          </button>
        </mat-form-field>

        <div
          class="remember-forgot-password"
          fxLayout="row"
          fxLayout.xs="column"
          fxLayoutAlign="space-between center"
          fxLayoutAlign="end"
        >
          <a
            class="forgot-password"
            *ngIf="isForgotPassword"
            [routerLink]="'/auth/forgot-password'"
          >
            Olvidaste tu contraseña?
          </a>
          <div
            class="register"
            *ngIf="isBloqueado"
            fxLayout="column"
            fxLayoutAlign="center center"
          >
            <a class="link" [routerLink]="'/auth/unlock'">Desbloquear Cuenta</a>
          </div>
        </div>
        <button
          mat-raised-button
          color="accent"
          class="submit-button"
          aria-label="LOGIN"
          [disabled]="loginForm.invalid || isLoading"
          *ngIf="switchLoginButton() && !isForgotPassword && !isBloqueado"
        >
          <span *ngIf="!isLoading">ENTRAR</span>
          <div class="loadingComponent" *ngIf="isLoading">
            <app-loading [isLoading]="isLoading" />
          </div>
        </button>
        <button
          mat-raised-button
          color="warn"
          class="submit-button"
          aria-label="LOGIN"
          *ngIf="isBloqueado || isForgotPassword || !switchLoginButton()"
          (click)="exit($event)"
        >
          SALIR
        </button>
      </form>
    </div>
    <div id="cuentas-wrapper" *ngIf="isSesionReciente && savedSessions">
      <div class="logo" fxHide.gt-xs>
        <img src="assets/images/logos/fuse.svg" />
      </div>
      <div class="title">INICIO DE SESION RECIENTE</div>
      <div
        class="content-logo-sesion"
        fxLayout="row"
        fxLayoutAlign="center"
        *ngIf="!isSavedSessions()"
      >
        <img src="assets/images/logos/logo.png" />
      </div>
      <div
        class="content-cuentas"
        *ngIf="isSavedSessions()"
        [style.gridTemplateColumns]="gridTemplateColumns"
      >
        <div
          class="table-row"
          *ngFor="let session of savedSessions; let i = index"
        >
          <div class="table-cell" (click)="addAccount(session)">
            <div class="deleteIcon">
              <mat-icon class="icon-position pointer" (click)="deleteSesion(i)"
                >delete</mat-icon
              >
              <img
                class="pointer imgPerfil"
                src="assets/images/default-avatar.png"
              />
            </div>
            <div class="pointer content-nombre">
              {{ session.nombre }} <br />
              {{ session.apellido }}
            </div>
          </div>
        </div>
      </div>
      <div class="agregar-sesion" fxLayout="row" fxLayoutAlign="center">
        <div>
          <button mat-raised-button (click)="addAccount()" color="primary">
            AGREGAR SESION
          </button>
        </div>
      </div>
    </div>
    <div class="register" fxLayout="column" fxLayoutAlign="center center">
      <span class="text">¿No tienes cuenta aun?</span>
      <a class="link" [routerLink]="'/auth/register'">Crear cuenta</a>
    </div>
    <div fxLayout="column" fxLayoutAlign="center center" class="copy">
      Nubyy 2019, Todos los derechos reservados.
    </div>
  </div>
</div>
